import { Skeleton } from "@mui/material";
import { useMeasurements } from "hooks/useMeasurements";
import { useParams } from "react-router-dom";
import { reportStepMetadata } from "util/reportStepMetadata";
import { FacilityProductMeasurementTable } from "./FacilityProductMeasurementTable";
import { FacilityProductsTable } from "./FacilityProductsTable";
import { ProductsWithMeasurementsTable } from "./ProductsWithMeasurementsTable";
import { StepperPageHeader } from "./Report/StepperPageHeader";

export type ProductsTableProps = {
  facilityId: string;
  showReportingYearPicker?: boolean;
};

export function ProductsTable(props: ProductsTableProps) {
  const { productId } = useParams<{ productId?: string }>();
  const { hasMeasurements, loading } = useMeasurements(props.facilityId);

  if (loading) {
    return <Skeleton />;
  }
  // Specific product in measurement mode renders its own special table
  // where we don't want the Products header/description
  if (productId && hasMeasurements) {
    return <FacilityProductMeasurementTable {...props} />;
  }

  let table;
  if (hasMeasurements) {
    table = <ProductsWithMeasurementsTable {...props} />;
  } else {
    table = <FacilityProductsTable {...props} />;
  }

  return (
    <>
      <StepperPageHeader
        header={reportStepMetadata.PRODUCTS.title}
        description={reportStepMetadata.PRODUCTS.getOverviewDescription()}
      />
      {table}
    </>
  );
}
